import i18n from "src/i18n";


export const getGeneralConsultationSteps = () => [
  {
    position: 1,
    title: i18n.t("getting-started"),
    hasRequiredFields: true,
  },
  {
    position: 2,
    title: i18n.t("background"),
    hasRequiredFields: false,
  },
  {
    position: 3,
    title: i18n.t("physical-checks"),
    hasRequiredFields: false,
  },
  {
    position: 4,
    title: i18n.t("observations"),
    hasRequiredFields: true,
  },
  {
    position: 5,
    title: i18n.t("procedures-and-tests"),
    hasRequiredFields: false,
  },
  {
    position: 6,
    title: i18n.t("treatment-plan"),
    hasRequiredFields: true,
  },
  {
    position: 7,
    title: i18n.t("documents"),
    hasRequiredFields: false,
  },
];
